import React, { FC } from 'react';
import { createGTMQueryString } from 'utils/common/http';
import { GoogleTagManagerProps } from 'components/atoms/GoogleTagManagerForBody';

const GoogleTagManagerForHead: FC<GoogleTagManagerProps> = (props) => {
  const { id, ...rest } = props;
  let queryString = createGTMQueryString(rest);
  if (queryString) {
    queryString = '&' + queryString;
  }
  return (
    <script
      async
      dangerouslySetInnerHTML={{
        __html: `
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl+ '${queryString}';f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','${id}');
            `,
      }}
    />
  );
};

export default GoogleTagManagerForHead;
